export default function isString(str) {
  return typeof str === 'string';
}